import React, { useState, useEffect, useRef } from "react";
import { DateTime } from "luxon";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Header from "../Header";
import Form from "../Form";
import Footer from "../Footer";
import Canvas from "../Canvas";
import {brandles} from '../../utils/constants'
import {getCurrentGameIndex} from "../../utils/helpers";
import {IStorageGameData, TBrand} from "../../types";

import "./PageWrapper.component.scss";

const PADDING_SIZE = 80;
const MOBILE_BREAKPOINT = 440;
const GA_TRACKING_ID = "UA-179415929-1";
const FB_TRACKING_ID = "409548333300465";

const PageWrapper = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [wrapperWidth, setWrapperWidth] = useState<number>(0);
  const [currentGame, setCurrentGame] = useState<TBrand>();
  const [currentGameData, setCurrentGameData] = useState<IStorageGameData>();
  const [currentDate, setCurrentDate] = useState(DateTime.now());

  const { pickedBrand, gameNumber, pickedFilter } =
    getCurrentGameIndex(currentDate);

  //FB Analytics  
  ReactPixel.init(FB_TRACKING_ID);
  ReactPixel.pageView(); 

  //GA Analytics
  ReactGA.initialize(GA_TRACKING_ID);
  ReactGA.pageview(window.location.pathname + window.location.search);  

  useEffect(() => {
    if (pickedBrand) setCurrentGame(brandles.brands[pickedBrand - 1]);
    updateWrapWidth();
  }, [currentDate]);

  useEffect(() => {
    if (wrapperRef && window) {
      window.addEventListener("resize", updateWrapWidth);

      return () => window.removeEventListener("resize", updateWrapWidth);
    }
  }, [window.screen.width]);

  const updateWrapWidth = () => {
    if (wrapperRef?.current) {
      setWrapperWidth(wrapperRef?.current?.clientWidth);
    }
  };

  const testButtons = () => {
    return (
      <>
        <button onClick={() => setCurrentDate(currentDate.plus({ day: 1 }))}>
          Day+
        </button>
        <button onClick={() => setCurrentDate(currentDate.minus({ day: 1 }))}>
          Day-
        </button>
      </>
    );
  };

  return (
    <div className="page-wrapper" ref={wrapperRef}>
      <Header currentGame={currentGame} />
      {currentGame && currentGameData && (
        <Canvas
          width={wrapperWidth - PADDING_SIZE}
          height={wrapperWidth - PADDING_SIZE < MOBILE_BREAKPOINT ? 200 : 300}
          filterType={pickedFilter}
          filterStep={currentGameData.currentGame.guesses.length + 1}
          image={currentGame.logoUrl}
          isGameEnded={currentGameData.currentGame.guesses.includes(
            currentGame.name,
            0
          )}
        />
      )}
      <Form
        currentGame={currentGame}
        getCurrentGameData={(data) => setCurrentGameData(data)}
        gameNumber={gameNumber}
      />
      {process.env.NODE_ENV === "development" && testButtons()}
      <Footer />
    </div>
  );
};;

export default PageWrapper;
